export const NO_PROGRAM_DATA = 'No Program Data'

export enum AnalyticsContentType {
  Tv = 'tv',
  Vod = 'vod',
  Show = 'tvShow',
  Catchup = 'catchup',
  Event = 'event',
}
